import { render, staticRenderFns } from "./CStatusWindowComponent.vue?vue&type=template&id=1baba9ea&scoped=true&"
import script from "./CStatusWindowComponent.vue?vue&type=script&lang=ts&"
export * from "./CStatusWindowComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CStatusWindowComponent.vue?vue&type=style&index=0&id=1baba9ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baba9ea",
  null
  
)

export default component.exports